import React from "react";
import { Route, Routes } from "react-router-dom";
import { RoutersConfig } from "./Config/RoutersConfig";
const AppRoutes = () => {
  return (
    <Routes>
      {RoutersConfig.map((route) => (
        <Route key={route.path} path={route.path} Component={route.Component} />
      ))}
    </Routes>
  );
};

export default AppRoutes;
